import './Alert.scss';
import Component from './Alert.js';
import ReactiveWrapper from '../ReactiveWrapper';
export default ReactiveWrapper(Component);